import { useState } from "react";
// import bg from "../../assets/images/imageFx.jpg";
 import bg from "../../assets/images/getImages.png";


export default function SearchPhoto() {
  const [code, setCode] = useState("");
  const [photoData, setPhotoData] = useState(null);
  const [error, setError] = useState("");

  const searchPhoto = async () => {
    if (!code) {
      setError("Please enter a code.");
      return;
    }

    try {
      const response = await fetch(
        `https://script.google.com/macros/s/AKfycbw78o6p3Qdu2O_ctIGlfjSspmuI__PYj7ym47Tc7VPnM0Sat3uOgKAhZ_6-hnjFmchnfQ/exec?code=${code}`
      );
      const data = await response.json();

      if (data.error) {
        setError(data.error);
        setPhotoData(null);
      } else {
        setError("");
        setPhotoData(data);
      }
    } catch (err) {
      setError("Failed to fetch data. Try again later.");
    }
  };

  return (
    <div
      className="w-full flex flex-col justify-start items-center gap-4 relative bg-gradient-to-b from-transparent to-black text-white min-h-screen px-4 py-8"
      style={{
        backgroundImage: `url(${bg})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundBlendMode: "overlay",
      }}
    >
      <p
        data-aos="fade-down"
        className="font-poppins text-[#76cfff] uppercase tracking-[4px] text-center text-[18px] font-bold pt-12"
      >
        Want to get your photos?
      </p>
      <h1
        data-aos="fade-down"
        className="text-center font-poppins uppercase font-semibold leading-none text-[50px] sm:text-[60px] md:text-[80px] lg:text-[100px] xl:text-[160px]"
      >
        Get all Your event photos now!
      </h1>

      <input
        type="text"
        value={code}
        data-aos="fade-right"
        onChange={(e) => setCode(e.target.value)}
        placeholder="Enter Your Event Code"
        className="bg-transparent border-none outline-none text-[#76cfff] placeholder:text-[#76cfff] placeholder:font-light placeholder:text-center font-poppins text-2xl max-w-xs px-6 py-4 rounded-full shadow-inner shadow-[#76cfff] mt-4"
      />
      <button
        data-aos="fade-left"
        onClick={searchPhoto}
        className="bg-[#76cfff] text-black rounded-[40px] px-10 py-4 font-poppins font-semibold text-[16px] mt-2"
      >
        Search
      </button>

      <div className="w-full flex flex-col justify-center items-center mt-6 text-center">
        {error && (
          <span className="font-poppins text-red-500 uppercase tracking-[4px] text-[18px] font-bold pt-12">
            {error}
          </span>
        )}

        {photoData && (
          <div className="mt-8">
            <h2 className="font-poppins text-white text-2xl sm:text-3xl font-bold pt-4">
              Here is the Photos of {photoData.name} Event!
            </h2>
            <p className="font-poppins text-[#76cfff] uppercase tracking-[4px] text-[18px] font-bold py-4">
              Hope You Like it
            </p>
            <a
              href={photoData.link}
              target="_blank"
              rel="noopener noreferrer"
              className="font-poppins text-orange-500 text-2xl font-bold underline"
            >
              __View Photos__
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
